import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { getMarathonWithDistances } from "api/thunk/marathons/getActions/getMarathonWithDistances";
import { getMarathonAdminById } from "api/thunk/marathons/getActions/getMarathonAdminById";
import { getMarathonsDistancesPrice } from "api/thunk/marathons/getActions/getMarathonsDistancesPrice";
import { getMarathonsById } from "api/thunk/marathons/getActions/getMarathonsById";
import { getMarathonsAsAdmin } from "api/thunk/marathons/getActions/getMarathonsAsAdmin";
import { getMarathonsDistances } from "api/thunk/marathons/getActions/getMarathonsDistances";
import { getMarathonsActive } from "api/thunk/marathons/getActions/getMarathonsActive";
import { getMyMarathonsWithUnfinishedRegistration } from "api/thunk/marathons/getActions/getMyMarathonsWithUnfinishedRegistration";
import { getMarathonsHasUserInsurance } from "api/thunk/marathons/getActions/getMarathonsHasUserInsurance";
import { deleteMarathons } from "api/thunk/marathons/deleteActions/deleteMarathons";
import { deleteMarathonsNonActivatedPromocodes } from "api/thunk/marathons/deleteActions/deleteMarathonsNonActivatedPromocodes";
import { getMarathonsLookup } from "api/thunk/marathons/getActions/getMarathonsLookup";
import { getMarathonUserRegistered } from "api/thunk/marathons/getActions/getMarathonUserRegistered";
import { getMarathons } from "api/thunk/marathons/getActions/getMarathons";
import { getMarathonParticipantImages } from "api/thunk/marathons/getActions/getMarathonParticipantImages";
import { getMyMarathonParticipantImages } from "api/thunk/marathons/getActions/getMyMarathonParticipantImages";


const marathonSlice = createSlice({
  name: "marathons",
  initialState,
  reducers: {
    setMarathonId: (state, action) => {
      state.marathonId = action.payload;
      localStorage.setItem("marathonId", action.payload.toString());
    },
    setIsInsuranceNeeded: (state, action) => {
      state.marathonsById.params.insurance = action.payload;
    },
    setSelectedDistance: (state, action) => {
      state.marathonsById.params.distance = action.payload;
    },
    setMarathonsLookupId: (state, action) => {
      state.marathonsLookupId = action.payload;
    },
    setMarathonDistancePrice: (state, action) => {
      state.marathonsDistancesPrice.response.data = action.payload;
    },
    //marathons
    setMarathonsPage: (state, action) => {
      state.marathons.params.page = action.payload
    },
    setMarathonsPageSize: (state, action) => {
      state.marathons.params.pageSize = action.payload
    },
    setMarathonsSearchTerm: (state, action) => {
      state.marathons.params.filter = action.payload
    },
    //marathons_lookup
    setMarathonsLookupLoading: (state, action) => {
      state.marathonsLookup.params.loading = action.payload;
    },
    setAllMarathonsLookup: (state, action) => {
      state.marathonsLookup.response.data = action.payload ?? [];
    },
    setMarathonsLookupPageSize: (state, action) => {
      state.marathonsLookup.params.pageSize = action.payload;
    },
    setMarathonsLookupHasMore: (state, action) => {
      state.marathonsLookup.params.hasMore = action.payload;
    },
    setMarathonsLookupPage: (state, action) => {
      state.marathonsLookup.params.page = action.payload;
    },
    setMarathonLookupName: (state, action) => {
      state.marathonsLookup.params.name = action.payload;
    },
    //getMarathonParticipantImages
    setMarathonParticipantImagesPage: (state, action) => {
      state.marathonParticipantImages.params.page = action.payload
    },
    setMarathonParticipantImagesPageSize: (state, action) => {
      state.marathonParticipantImages.params.pageSize = action.payload
    },
    setMarathonParticipantImagesStartNumber: (state, action) => {
      state.marathonParticipantImages.params.startNumber = action.payload
    },
    //getMyMarathonParticipantImages
    setMarathonMyParticipantImagesPage: (state, action) => {
      state.marathonMyParticipantImages.params.page = action.payload
    },
    setMarathonMyParticipantImagesPageSize: (state, action) => {
      state.marathonMyParticipantImages.params.pageSize = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      //get_marathons_with_distances
      .addCase(getMarathonWithDistances.pending, (state) => {
        state.marathonWithDistances.loading = true;
        state.marathonWithDistances.error = null;
      })
      .addCase(getMarathonWithDistances.fulfilled, (state, action) => {
        state.marathonWithDistances.loading = false;
        state.marathonWithDistances.data = action.payload;
      })
      .addCase(getMarathonWithDistances.rejected, (state, action) => {
        state.marathonWithDistances.loading = false;
        state.marathonWithDistances.data = null;
        state.marathonWithDistances.error =
          action.error.message || "Неизвестная ошибка";
      })

      //get_marathon_admin_by_id
      .addCase(getMarathonAdminById.pending, (state) => {
        state.marathonAdminById.loading = true;
        state.marathonAdminById.error = null;
      })
      .addCase(getMarathonAdminById.fulfilled, (state, action) => {
        state.marathonAdminById.loading = false;
        state.marathonAdminById.data = action.payload;
        state.marathonId = action.payload.id;
      })
      .addCase(getMarathonAdminById.rejected, (state, action) => {
        state.marathonAdminById.loading = false;
        state.marathonAdminById.error =
          action.error.message || "Неизвестная ошибка";
      })

      //get_marathon_user_registered
      .addCase(getMarathonUserRegistered.pending, (state) => {
        state.userRegistered.loading = true;
        state.userRegistered.error = null;
      })
      .addCase(getMarathonUserRegistered.fulfilled, (state, action) => {
        state.userRegistered.loading = false;
        state.userRegistered.data = action.payload;
        state.marathonId = action.payload.id;
      })
      .addCase(getMarathonUserRegistered.rejected, (state, action) => {
        state.userRegistered.loading = false;
        state.userRegistered.error =
          action.error.message || "Неизвестная ошибка";
        state.userRegistered.data = null;
      })

      //get_marathons
      .addCase(getMarathons.pending, (state) => {
        state.marathons.response.loading = true;
        state.marathons.response.error = null;
      })
      .addCase(getMarathons.fulfilled, (state, action) => {
        state.marathons.response.loading = false;
        state.marathons.response.data = action.payload;
      })
      .addCase(getMarathons.rejected, (state, action) => {
        state.marathons.response.loading = false;
        state.marathons.response.error =
          action.error.message || "Неизвестная ошибка";
        state.marathons.response.data = null;
      })

      //get_marathons_distances_price
      .addCase(getMarathonsDistancesPrice.pending, (state) => {
        state.marathonsDistancesPrice.response.loading = true;
        state.marathonsDistancesPrice.response.error = null;
      })
      .addCase(getMarathonsDistancesPrice.fulfilled, (state, action) => {
        state.marathonsDistancesPrice.response.loading = false;
        state.marathonsDistancesPrice.response.data = action.payload;
      })
      .addCase(getMarathonsDistancesPrice.rejected, (state, action) => {
        state.marathonsDistancesPrice.response.loading = false;
        state.marathonsDistancesPrice.response.error =
          action.error.message || "Неизвестная ошибка";
        state.marathonsDistancesPrice.response.data = null;
      })

      //get_marathons_by_id
      .addCase(getMarathonsById.pending, (state) => {
        state.marathonsById.response.loading = true;
        state.marathonsById.response.error = null;
      })
      .addCase(getMarathonsById.fulfilled, (state, action) => {
        state.marathonsById.response.loading = false;
        state.marathonsById.response.data = action.payload;
      })
      .addCase(getMarathonsById.rejected, (state, action) => {
        state.marathonsById.response.loading = false;
        state.marathonsById.response.error =
          action.error.message || "Неизвестная ошибка";
        state.marathonsById.response.data = null;
      })

      //get_marathons_as_admin
      .addCase(getMarathonsAsAdmin.pending, (state) => {
        state.marathonsAsAdmin.response.loading = true;
        state.marathonsAsAdmin.response.error = null;
      })
      .addCase(getMarathonsAsAdmin.fulfilled, (state, action) => {
        state.marathonsAsAdmin.response.loading = false;
        state.marathonsAsAdmin.response.data = action.payload;
      })
      .addCase(getMarathonsAsAdmin.rejected, (state, action) => {
        state.marathonsAsAdmin.response.loading = false;
        state.marathonsAsAdmin.response.error =
          action.error.message || "Неизвестная ошибка";
        state.marathonsAsAdmin.response.data = null;
      })

      //get_marathons_distances
      .addCase(getMarathonsDistances.pending, (state) => {
        state.marathonsDistances.response.loading = true;
        state.marathonsDistances.response.error = null;
      })
      .addCase(getMarathonsDistances.fulfilled, (state, action) => {
        state.marathonsDistances.response.loading = false;
        state.marathonsDistances.response.data = action.payload;
      })
      .addCase(getMarathonsDistances.rejected, (state, action) => {
        state.marathonsDistances.response.loading = false;
        state.marathonsDistances.response.error =
          action.error.message || "Неизвестная ошибка";
        state.marathonsDistances.response.data = null;
      })

      //get_marathons_active
      .addCase(getMarathonsActive.pending, (state) => {
        state.marathonsActive.response.loading = true;
        state.marathonsActive.response.error = null;
      })
      .addCase(getMarathonsActive.fulfilled, (state, action) => {
        state.marathonsActive.response.loading = false;
        state.marathonsActive.response.data = action.payload;
      })
      .addCase(getMarathonsActive.rejected, (state, action) => {
        state.marathonsActive.response.loading = false;
        state.marathonsActive.response.error =
          action.error.message || "Неизвестная ошибка";
        state.marathonsActive.response.data = null;
      })

      //get_my_marathons_with_unfinished_registration
      .addCase(getMyMarathonsWithUnfinishedRegistration.pending, (state) => {
        state.myMarathonsWithUnfinishedRegistration.response.loading = true;
        state.myMarathonsWithUnfinishedRegistration.response.error = null;
      })
      .addCase(
        getMyMarathonsWithUnfinishedRegistration.fulfilled,
        (state, action) => {
          state.myMarathonsWithUnfinishedRegistration.response.loading = false;
          state.myMarathonsWithUnfinishedRegistration.response.data =
            action.payload;
        }
      )
      .addCase(
        getMyMarathonsWithUnfinishedRegistration.rejected,
        (state, action) => {
          state.myMarathonsWithUnfinishedRegistration.response.loading = false;
          state.myMarathonsWithUnfinishedRegistration.response.error =
            action.error.message || "Неизвестная ошибка";
          state.myMarathonsWithUnfinishedRegistration.response.data = null;
        }
      )

      //get_marathons_has_user_insurance
      .addCase(getMarathonsHasUserInsurance.pending, (state) => {
        state.marathonsHasUserInsurance.response.loading = true;
        state.marathonsHasUserInsurance.response.error = null;
      })
      .addCase(getMarathonsHasUserInsurance.fulfilled, (state, action) => {
        state.marathonsHasUserInsurance.response.loading = false;
        state.marathonsHasUserInsurance.response.data = action.payload;
      })
      .addCase(getMarathonsHasUserInsurance.rejected, (state, action) => {
        state.marathonsHasUserInsurance.response.loading = false;
        state.marathonsHasUserInsurance.response.error =
          action.error.message || "Неизвестная ошибка";
        state.marathonsHasUserInsurance.response.data = null;
      })

      //delete_marathons
      .addCase(deleteMarathons.pending, (state) => {
        state.deleteMarathons.loading = true;
        state.deleteMarathons.error = null;
      })
      .addCase(deleteMarathons.fulfilled, (state, action) => {
        state.deleteMarathons.loading = false;
        state.deleteMarathons.data = action.payload;
      })
      .addCase(deleteMarathons.rejected, (state, action) => {
        state.deleteMarathons.loading = false;
        state.deleteMarathons.error =
          action.error.message || "Неизвестная ошибка";
        state.deleteMarathons.data = null;
      })

      //delete_marathons_non_activated_promocodes
      .addCase(deleteMarathonsNonActivatedPromocodes.pending, (state) => {
        state.deleteMarathonsNonActivatedPromocodes.loading = true;
        state.deleteMarathonsNonActivatedPromocodes.error = null;
      })
      .addCase(
        deleteMarathonsNonActivatedPromocodes.fulfilled,
        (state, action) => {
          state.deleteMarathonsNonActivatedPromocodes.loading = false;
          state.deleteMarathonsNonActivatedPromocodes.data = action.payload;
        }
      )
      .addCase(
        deleteMarathonsNonActivatedPromocodes.rejected,
        (state, action) => {
          state.deleteMarathonsNonActivatedPromocodes.loading = false;
          state.deleteMarathonsNonActivatedPromocodes.error =
            action.error.message || "Неизвестная ошибка";
          state.deleteMarathonsNonActivatedPromocodes.data = null;
        }
      )

      //get_marathons_lookup
      .addCase(getMarathonsLookup.pending, (state) => {
        state.marathonsLookup.response.loading = true;
        state.marathonsLookup.response.error = null;
      })
      .addCase(getMarathonsLookup.fulfilled, (state, action) => {
        state.marathonsLookup.response.loading = false;
        state.marathonsLookup.response.data = action.payload;
      })
      .addCase(getMarathonsLookup.rejected, (state, action) => {
        state.marathonsLookup.response.loading = false;
        state.marathonsLookup.response.error =
          action.error.message || "Неизвестная ошибка";
        state.marathonsLookup.response.data = null;
      })

      //getMarathonParticipantImages
      .addCase(getMarathonParticipantImages.pending, (state) => {
        state.marathonParticipantImages.response.loading = true;
        state.marathonParticipantImages.response.error = null;
      })
      .addCase(getMarathonParticipantImages.fulfilled, (state, action) => {
        state.marathonParticipantImages.response.loading = false;
        state.marathonParticipantImages.response.data = action.payload;
      })
      .addCase(getMarathonParticipantImages.rejected, (state, action) => {
        state.marathonParticipantImages.response.loading = false;
        state.marathonParticipantImages.response.error =
          action.error.message || "Неизвестная ошибка";
        state.marathonParticipantImages.response.data = null;
      })

      //getMyMarathonParticipantImages
      .addCase(getMyMarathonParticipantImages.pending, (state) => {
        state.marathonMyParticipantImages.response.loading = true;
        state.marathonMyParticipantImages.response.error = null;
      })
      .addCase(getMyMarathonParticipantImages.fulfilled, (state, action) => {
        state.marathonMyParticipantImages.response.loading = false;
        state.marathonMyParticipantImages.response.data = action.payload;
      })
      .addCase(getMyMarathonParticipantImages.rejected, (state, action) => {
        state.marathonMyParticipantImages.response.loading = false;
        state.marathonMyParticipantImages.response.error =
          action.error.message || "Неизвестная ошибка";
        state.marathonMyParticipantImages.response.data = null;
      })
  },
});

export const {
  //marathonId
  setMarathonId,
  //marathons
  setMarathonsPage,
  setMarathonsPageSize,
  setMarathonsSearchTerm,
  //marathons_by_id
  setIsInsuranceNeeded,
  setSelectedDistance,
  //marathons_distances_price
  setMarathonDistancePrice,
  //marathons_lookup
  setMarathonsLookupId,
  setAllMarathonsLookup,
  setMarathonsLookupPageSize,
  setMarathonsLookupHasMore,
  setMarathonsLookupLoading,
  setMarathonsLookupPage,
  setMarathonLookupName,
  //marathon_participant_images
  setMarathonParticipantImagesPage,
  setMarathonParticipantImagesPageSize,
  setMarathonParticipantImagesStartNumber,
  //marathon_my_participant_images
  setMarathonMyParticipantImagesPage,
  setMarathonMyParticipantImagesPageSize,
} = marathonSlice.actions;
export default marathonSlice.reducer;
